import cn from 'clsx';
import { PropsWithChildren } from 'react';

import { BasicButton } from './BasicButton';
import type { IButtonProps } from './schemas';

export function SimpleButton({
  disabled,
  onClick,
  className,
  children,
  ...restButtonProps
}: IButtonProps & PropsWithChildren) {
  return (
    <BasicButton
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'text-primary p-0 border-0 relative font-normal text-center',
        !disabled && 'filter hover:text-primary-interaction',
        !disabled && 'filter focus:text-primary-interaction',
        !disabled && 'filter active:text-primary-interaction',
        disabled && 'cursor-not-allowed disabled',
        className ?? '',
      )}
      {...restButtonProps}
    >
      {children}
    </BasicButton>
  );
}
